import { MUTATIONS } from '../constants';
import { EVENTS } from '../nameConstants';

const mutations = {
    [MUTATIONS.HISTORY.SET_SHIPMENTS](state, shipments) {
        state.shipments = shipments;
    },

    [MUTATIONS.HISTORY.SET_SHIPMENT_DIRECTION](state, shipmentDirections) {
        state.shipmentDirections = shipmentDirections.map(d => ({
            label: mapShipmentDirectionLabel(d),
            value: d
        }));
    },

    [MUTATIONS.HISTORY.SET_SEARCH_OPTIONS](state, searchOptions) {
        state.searchOptions = searchOptions;
    },

    [MUTATIONS.HISTORY.SET_DELIVERY_STATUSES](state, deliveryStatuses) {
        state.deliveryStatuses = deliveryStatuses;
    },

    [MUTATIONS.HISTORY.DELETE_SHIPMENTS](state, ids) {
        const shipments = state.shipments.filter((element) => !ids.includes(element.id));

        state.shipments = shipments;
    },

    [MUTATIONS.HISTORY.SET_SALES_PRODUCTS](state, salesProducts) {
        state.salesProducts = salesProducts;
    },

    [MUTATIONS.HISTORY.SET_TRANSPORT_COMPANIES](state, transportCompanies) {
        state.transportCompanies = transportCompanies;
    },

    [MUTATIONS.HISTORY.SET_COMPANY_ACCOUNTS](state, accounts) {
        state.accounts = accounts;
    },
    [MUTATIONS.HISTORY.SET_SELECTED_ROWS](state, rows) {
        state.selectedRows = rows;
    },
    [MUTATIONS.HISTORY.SET_FILTER](state, filter) {
        state.filter = filter;
    },
    [MUTATIONS.HISTORY.RESTORE_SHIPMENTS](state, ids) {
        const shipments = state.shipments.filter((element) => !ids.includes(element.id));
        state.shipments = shipments;
    },
    [MUTATIONS.HISTORY.SET_COUNTRIES](state, countries) {
        state.countries = countries;
    }
    
};
function mapShipmentDirectionLabel(direction) {
    switch (direction) {
        case 3:
        case 'ImportWithPickup':
            return 'Import with Pickup';
        default:
            return direction;
    }
}
export default mutations;
